<template>
  <div>
    <div class="bottom-line item-row-alignment padding-bottom-10">
      <div class="item-row-alignment-center">
        <weex-image
          :src="personLogo"
          style="height: 24px;width: 24px; margin-right: 5px"
          ></weex-image>
        <weex-text class="font-weight-bold font-size-lg">{{ getClientName }}</weex-text>
      </div>
      <div class="item-row-alignment-center item-align-right">
        <weex-image
          :src="callLogo"
          style="height: 24px;width: 24px; margin-right: 5px"
          ></weex-image>
        <weex-text class="font-weight-bold font-size-base">{{ getMobileNumber }}</weex-text>
      </div>
    </div>

    <div v-if="getDisplayElements && getDisplayElements.length"
         class="bottom-line padding-bottom-10">

      <div v-for="displayElement in getDisplayElements" :key="displayElement">
        <weex-text
            class="font-size-base margin-top-10"
            v-html="displayElement"
        ></weex-text>
      </div>
    </div>

<!--    <div class="bottom-line padding-bottom-10">
      <weex-text
        class="font-size-base margin-top-10"
        v-html="getDetailsWithLabel('Application ID', getAccountNumber)"
        ></weex-text>

      <weex-text
        v-if="merchantID"
        class="font-size-base margin-top-10"
        v-html="getDetailsWithLabel('Merchant ID', merchantID)"
        ></weex-text>

      <weex-text
        v-if="showAdditionLoanSummary && getTotalPrice && showLoanPrice"
        class="font-size-base margin-top-10"
        v-html="getDetailsWithLabel(loanPriceOrAmountTitle, getTotalPrice)"
        ></weex-text>

      <weex-text
        v-if="showAdditionLoanSummary && getProductDescription"
        class="font-size-base margin-top-10"
        v-html="getDetailsWithLabel('Product Details', getProductDescription)"
        ></weex-text>

      <weex-text
        class="font-size-base margin-top-10"
        v-html="getDetailsWithLabel('Status', getLoanStatusValue)"
        ></weex-text>

      <weex-text
        v-if="(isLoanRejected || isLoanWithdrawnByApplicant) && getLoanRejectionReason"
        class="font-size-base margin-top-10"
        v-html="getDetailsWithLabel('Rejection Reason', getLoanRejectionReason)"
        ></weex-text>

      <div
        v-if="showAdditionLoanSummary && (isLoanActive || isLoanApproved)"
        >
        <weex-text
          class="font-size-base margin-top-10"
          v-html="getDetailsWithLabel('Approved Amount', getApprovedAmount)"
        ></weex-text>

        <weex-text v-if="showEmiTenure"
          class="font-size-base margin-top-10"
          v-html="getDetailsWithLabel('EMI Tenure', getEmiTenure)"
        ></weex-text>
      </div>

       <weex-text v-if="getLenderLoanId"
          class="font-size-base margin-top-10"
          v-html="getDetailsWithLabel('Lender Loan ID', getLenderLoanId)"
          ></weex-text>

      <weex-text  v-if="getLenderLoanStatus"
        class="font-size-base margin-top-10"
        v-html="getDetailsWithLabel('Lender Loan Status', getLenderLoanStatus)"
        ></weex-text>


      <weex-text
        v-if="getPartnerMessage"
        class="font-size-base margin-top-10 text-color-black"
        v-html="getPartnerMessage"
      ></weex-text>

    </div>-->
  </div>
</template>

<script>
  import LoanScopeDataHolder from '../../data/model/LoanScopeDataHolder';
  import PrefManager from '../../data/model/PrefManager';
  import EzUtils from "../../utils/EzUtils";
  import { ImageResourcesUtil } from "../../utils/ImageResourcesUtil";
  import LoanStatusDetails, { LoanStatus } from "../../utils/LoanStatusDetails";
import { Constants } from '../Constants';

  const RUPEE = "\u20B9";
  const MERCHANT = "MERCHANT";

  export default {
    name: "LoanSummary",
    props: {
      ezLoan: {
        type: Object,
        required: true,
        default: () => ({})
      },

      merchantID: {
        type: String,
        default: ""
      }
    },

    methods: {
      getDetailsWithLabel(label, details) {
        return `<span style="color: blue">${label} : </span><span style="color: black">${details}</span>`;
      }
    },

    computed: {
      getClientName() {
        return this.ezLoan && this.ezLoan.loan ? this.ezLoan.loan.clientName : "";
      },

      getMobileNumber() {
        return this.ezLoan && this.ezLoan.loanDetails ? this.ezLoan.loanDetails.contact : "";
      },

      showAdditionLoanSummary() {
        return !this.isOnboardingLoan;
      },

      isOnboardingLoan() {
        return LoanScopeDataHolder.isOnboardingLoan();
      },

      getLeadEntity() {
        return this.ezLoan && this.ezLoan.loanDetails ? this.ezLoan.loanDetails.lead_entity : "";
      },

      isLoanApproved() {
        return EzUtils.areEqualString(LoanStatus.APPROVED, this.getLoanStatus, true);
      },

      isLoanActive() {
        return EzUtils.areEqualString(LoanStatus.ACTIVE, this.getLoanStatus, true);
      },

      isLoanRejected() {
        return EzUtils.areEqualString(LoanStatus.REJECTED, this.getLoanStatus, true);
      },

      isLoanWithdrawnByApplicant() {
        return EzUtils.areEqualString(LoanStatus.WITHDRAWN_BY_APPLICANT, this.getLoanStatus, true);
      },

      getAccountNumber() {
        return this.ezLoan && this.ezLoan.loan ? this.ezLoan.loan.accountNo : "";
      },

      getProductDescription() {
        /*return this.ezLoan && this.ezLoan.loanDetails
          ? EzUtils.join(" - ", this.ezLoan.loanDetails.brand, this.ezLoan.loanDetails.model)
          : "";*/
        return "";
      },

      getLoanStatus() {
        return this.ezLoan && this.ezLoan.loan && this.ezLoan.loan.status
          ? this.ezLoan.loan.status.value
          : "";
      },

      getLoanStatusValue() {
        const loanStatusDescription =
          LoanStatusDetails.getLoanStatusDescription(this.getLoanStatus);
        return this.isOnboardingLoan
          ? loanStatusDescription.onboardingStatusMessage :
          loanStatusDescription.defaultStatusMessage
      },

      getLoanRejectionReason() {
        return this.ezLoan && this.ezLoan.loanDetails
          ? this.ezLoan.loanDetails.rejection_reason
          : "";
      },

      getPartnerMessage() {
        return this.ezLoan && this.ezLoan.loanDetails
          ? this.ezLoan.loanDetails.partner_message
          : "";
      },

      getTotalPrice() {
        const price = this.ezLoan && this.ezLoan.loanDetails ? this.ezLoan.loanDetails.price : "";
        return price ? EzUtils.join(" ", RUPEE, (Math.round(price * 100) / 100).toString()) : "";
      },

      getApprovedAmount() {
        const approvedAmount = this.ezLoan && this.ezLoan.loanDetails
          ? this.ezLoan.loanDetails.approved_amount
          : "";
        return approvedAmount
          ? EzUtils.join(" ", RUPEE, (Math.round(approvedAmount * 100) / 100).toString())
          : "";
      },

      getEmiTenure() {
        if (this.ezLoan && this.ezLoan.loan && this.ezLoan.loan.numberOfRepayments) {
          return this.ezLoan.loan.numberOfRepayments.toString();
        }
        return ''
      },

      personLogo() {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.PERSON);
      },

      callLogo() {
        return ImageResourcesUtil.getImageLink(ImageResourcesUtil.CALL);
      },

      showLoanPrice() {
        return PrefManager.showLoanPrice();
      },

      showEmiTenure() {
        return PrefManager.showEmiTenure();
      },

      loanPriceOrAmountTitle(){
        return PrefManager.isUsePriceForLoanAmount() ? "Loan Amount" : "Loan Price"
      },

      getLenderLoanId() {
      return this.ezLoan && this.ezLoan.lenderLoanDetail
        && this.ezLoan.lenderLoanDetail[Constants.LENDER_LOAN_ID]
        ? this.ezLoan.lenderLoanDetail[Constants.LENDER_LOAN_ID]
        : null;
      },

      getLenderLoanStatus() {
        return this.ezLoan && this.ezLoan.lenderLoanDetail
          && this.ezLoan.lenderLoanDetail[Constants.LENDER_LOAN_STATUS]
          ? this.ezLoan.lenderLoanDetail[Constants.LENDER_LOAN_STATUS]
          : null;
      },

      getDisplayElements() {
        const displayElementsList = [];
        if (this.ezLoan && this.ezLoan.displayElements && this.ezLoan.displayElements.displayMap) {
          for (let [label, value] of Object.entries(this.ezLoan.displayElements.displayMap)) {
            displayElementsList.push(this.getDetailsWithLabel(label, value));
          }
        }

        return displayElementsList;
      }
    }
  }
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
